import React from "react";
import "./index.css"; // Pastikan CSS sudah diimpor
import { LanguageProvider } from './context/LanguageContext';
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen overflow-x-hidden bg-gradient-to-br from-gray-900 via-blue-900/20 to-purple-900/20">
        <Navbar />
        <Hero />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
